import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "25",
  viewBox: "0 0 24 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M10.7422 5.58581C14.9364 5.01215 19.3188 7.31687 21.9997 12.5C21.4902 13.4851 20.9192 14.3662 20.2997 15.1434",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "square"
    }, null, -1),
    _createElementVNode("path", {
      d: "M3.70711 2.79289L3 2.08579L1.58579 3.5L2.29289 4.20711L3 3.5L3.70711 2.79289ZM20.2929 22.2071L21 22.9142L22.4142 21.5L21.7071 20.7929L21 21.5L20.2929 22.2071ZM3 3.5L2.29289 4.20711L20.2929 22.2071L21 21.5L21.7071 20.7929L3.70711 2.79289L3 3.5Z",
      fill: "currentColor"
    }, null, -1),
    _createElementVNode("path", {
      d: "M10.3327 11.3948L10.8864 10.562L9.22094 9.45469L8.66727 10.2874L9.5 10.8411L10.3327 11.3948ZM14.2126 15.8327L15.0453 15.2791L13.938 13.6136L13.1052 14.1673L13.6589 15L14.2126 15.8327ZM12 15.5V14.5C10.8954 14.5 10 13.6046 10 12.5H9H8C8 14.7091 9.79086 16.5 12 16.5V15.5ZM9 12.5H10C10 12.0896 10.1225 11.711 10.3327 11.3948L9.5 10.8411L8.66727 10.2874C8.24565 10.9215 8 11.6836 8 12.5H9ZM13.6589 15L13.1052 14.1673C12.789 14.3775 12.4103 14.5 12 14.5V15.5V16.5C12.8164 16.5 13.5785 16.2543 14.2126 15.8327L13.6589 15Z",
      fill: "currentColor"
    }, null, -1),
    _createElementVNode("path", {
      d: "M6.12816 7.5C4.54597 8.66112 3.12355 10.3278 2 12.5001C5.4666 19.2023 11.7785 21.0916 16.8492 18.1681",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "square"
    }, null, -1)
  ]))]))
}
export default { render: render }